import React from "react";
import useDeviceType from "../../hooks/useDeviceType";
import {FormattedMessage, useIntl} from "react-intl";

import "./ResetPassword.style.scss"
const ResetPassword = ({vm}) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

    const intl = useIntl();
    const {isMobile} = useDeviceType();

    return (
        <div className="ResetPassword">
            <div className="resetPasswordTitle">
                <FormattedMessage id={"myAccountView.myProfile.resetPasswordTitle"}/>
            </div>
            <form onSubmit={vm.handlePasswordSubmit}>
                <div className="inputField">
                    <label><FormattedMessage id={"myAccountView.myProfile.currentPassword"} /></label>
                    <input
                        type="password"
                        placeholder={intl.formatMessage({id: "myAccountView.myProfile.currentPassword"})}
                        value={vm.currentPassword}
                        onChange={(e)=>vm.handlePasswordChange("currentPassword", e.target.value)}
                        className={vm.passwordErrors.currentPassword ? 'error' : ''}
                    />
                    {vm.passwordErrors.currentPassword &&
                        <span className="errorMessage">{vm.passwordErrors.currentPassword}</span>}
                </div>
                <div className="inputField">
                    <label>
                        <FormattedMessage id={"myAccountView.myProfile.newPassword"} />
                    </label>
                    <input
                        type={showPassword ? 'text' : 'password'}
                        placeholder={intl.formatMessage({id: "myAccountView.myProfile.newPassword"}) + " (min 6 characters)"}
                        value={vm.newPassword}
                        onChange={(e)=>vm.handlePasswordChange("newPassword", e.target.value)}
                        className={vm.passwordErrors.newPassword ? 'error' : ''}
                    /><i className="password fa-solid fa-eye" onClick={ () => {
                    setShowPassword(!showPassword)
                }} />
                    {vm.passwordErrors.newPassword &&
                        <span className="errorMessage">{vm.passwordErrors.newPassword}</span>}
                </div>
                <div className="inputField">
                    <label>
                        <FormattedMessage id={"myAccountView.myProfile.confirmPassword"} />
                    </label>
                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder={intl.formatMessage({id: "myAccountView.myProfile.confirmPassword"})}
                        value={vm.confirmPassword}
                        onChange={(e)=>vm.handlePasswordChange("confirmPassword", e.target.value)}
                        className={vm.passwordErrors.confirmPassword ? 'error' : ''}
                    /><i className="confirmPassword fa-solid fa-eye" onClick={ () => {
                                                                setShowConfirmPassword(!showConfirmPassword)
                                                            }} />
                {vm.passwordErrors.confirmPassword &&
                        <span className="errorMessage">{vm.passwordErrors.confirmPassword}</span>}
                </div>
                <button type="submit" disabled={vm.passwordErrors.newPassword || vm.passwordErrors.confirmPassword}
                        style={{display: "none"}}
                >
                    Submit
                </button>
            </form>
        </div>
    );
}

export default ResetPassword;